import React, { memo, useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core/styles';
import PageContext from '../../../../../contexts/PageContext';
import { safetyCheck } from '../../../../../utils';
import fontSizeOptions from '../../../../../constants/fontSizeOptions';
import { LeftHeading } from '../../containers/HeadingModifiers';

const useStyles = makeStyles({
  root: {
    fontSize: (props) => props,
  },
});

const AwardItem = ({ item, fontSize, key }) => {
  const classes = useStyles({
    fontSize: fontSizeOptions['text-base'] + fontSize,
  });

  return (
    <div key={key}>
      <div className="flex justify-between items-center">
        <div className="flex flex-col text-left mr-2">
          <h6
            className="font-semibold"
            style={{
              fontSize: fontSizeOptions['text-base'] + fontSize,
            }}
          >
            {`${item.title} ${
              item.date && `(${new Date(item.date).getFullYear()})`
            }`}
          </h6>
          <span
            className="text-xs"
            style={{
              fontSize: fontSizeOptions['text-base'] + fontSize,
            }}
          >
            {item.awarder}
          </span>
        </div>
      </div>
      {item.summary && (
        <ReactMarkdown
          className={`markdown mt-2 ${classes.root}`}
          source={item.summary}
        />
      )}
    </div>
  );
};

const AwardsE = () => {
  const { data, heading: Heading } = useContext(PageContext);
  const { fontSize, lrMargins } = data.metadata.margins;

  return safetyCheck(data.awards) ? (
    <div>
      <LeftHeading Heading={Heading} fontSize={fontSize} margin={lrMargins}>
        {data.awards.heading}
      </LeftHeading>

      <div className="grid gap-4 m-4">
        {data.awards.items.map((x) => (
          <AwardItem
            key={x.id}
            item={x}
            language={data.metadata.language}
            fontSize={fontSize}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default memo(AwardsE);
